import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Megaphone } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { cleanDate } from "services/misc";

type CCProps = {
  viewBool: boolean;
  func?: (type: string) => void;
  data: any;
  viewFunc?: (data: any) => void;
  currency: any;
};

const CampaignCard = ({
  viewBool,
  func,
  data,
  viewFunc,
  currency,
}: CCProps) => {
  return (
    <Card
      className={`w-full p-0 border-0  ${viewBool ? "border" : "shadow"} `}
      onClick={() => {
        viewFunc?.(data);
      }}
    >
      <CardContent className="pt-6 p-3 md:p-6">
        <div className="flex justify-between item-center">
          <div className="flex justify-start items-center gap-2 w-full">
            <div className="bg-gray-100 p-2 rounded-md">
              <Megaphone />
            </div>
            <div>
              <h6 className="text-md font-medium capitalize text-black">
                {data.name}
              </h6>
              <p className="font-normal text-gray-500">#{data.campaignId}</p>
            </div>
          </div>
          <div>
            <Badge
              className={`tracking-tighter ${
                data.status === "pending"
                  ? "bg-yellow-300 text-black"
                  : data.status === "active"
                  ? " bg-emerald-600"
                  : "bg-red-600"
              }`}
            >
              {data.status === "pending"
                ? "Pending"
                : data.status === "active"
                ? "Live"
                : "Ended"}
            </Badge>
          </div>
        </div>
        <Separator className="my-2" />
        <div className="grid grid-cols-3 divide-x">
          <div className="text-center">
            <span className="text-gray-400 text-sm">Start Date</span>
            <h6 className="text-sm font-medium">
              {cleanDate(data.start_date)}
            </h6>
          </div>
          <div className="text-center">
            <span className="text-gray-400 text-sm">End Date</span>
            <h6 className="text-sm font-medium">{cleanDate(data.end_date)}</h6>
          </div>
          <div className="text-center">
            <span className="text-gray-400 text-sm">Charge</span>
            <h6 className="text-sm font-medium">
              {currency}
              {data.charge}
            </h6>
          </div>
        </div>
        <Separator className="my-2" />
        <div className="flex justify-end items-center">
          <span className="text-sm text-gray-500 capitalize">
            {cleanDate(data.createdAt)}
          </span>
        </div>
      </CardContent>
    </Card>
  );
};

export default CampaignCard;
